export default __webpack_public_path__ + "static/media/OC.9fa1e9d4.webp";